import $ from 'jquery'

export class CalculatorSickCommon {

  constructor() {
    this.$container = $('.calculator-sick-common')

    if (!this.$container.length) return

    this.$form = this.$container.find('form')
    this.$inputs = this.$form.find('input')
    this.$containerWithResult = this.$container.find('.with-results')
    this.$containerWithoutResult = this.$container.find('.no-result')
    this.$feeInput = this.$container.find('#sickcommon-fee')
    this.$baseInput = this.$container.find('#sickcommon-base')
    this.$daysInput = this.$container.find('#sickcommon-days')
    this.$eligibility = this.$container.find('#sickcommon-eligibility')

    // read limits and rates from data attributes (set in Twig via ACF)
    const baseMinAttr = this.$container.attr('data-base-min')
    const baseMaxAttr = this.$container.attr('data-base-max')
    const parsedMin = parseFloat(baseMinAttr)
    const parsedMax = parseFloat(baseMaxAttr)
    this.baseLimits = {
      min: Number.isFinite(parsedMin) ? parsedMin : 950.98,
      max: Number.isFinite(parsedMax) ? parsedMax : 4720.5
    }

    const rateTier2 = parseFloat(this.$container.attr('data-rate-tier2'))
    const rateTier3 = parseFloat(this.$container.attr('data-rate-tier3'))
    const tier1End = parseInt(this.$container.attr('data-tier1-end'), 10)
    const tier2End = parseInt(this.$container.attr('data-tier2-end'), 10)
    const maxMonthsFee = parseInt(this.$container.attr('data-max-months-fee'), 10)

    this.rates = {
      tier2: Number.isFinite(rateTier2) ? rateTier2 / 100 : 0.6,
      tier3: Number.isFinite(rateTier3) ? rateTier3 / 100 : 0.75
    }
    this.tiers = {
      tier1End: Number.isFinite(tier1End) ? tier1End : 3,
      tier2End: Number.isFinite(tier2End) ? tier2End : 20
    }
    this.maxMonthsFee = Number.isFinite(maxMonthsFee) ? maxMonthsFee : 2

    this.$benefitMonths = this.$container.find('#sickcommon-text-month')
    this.$monthlyAmount = this.$container.find('#sickcommon-text-contribution')
    this.$netAmount = this.$container.find('#sickcommon-text-net')
    this.$error = this.$container.find('.calc-error')

    // detail lines
    this.$details = this.$container.find('#sickcommon-details')
    this.$line1 = this.$container.find('#sickcommon-line-1')
    this.$line2 = this.$container.find('#sickcommon-line-2')
    this.$line3 = this.$container.find('#sickcommon-line-3')
    this.$lineTotal = this.$container.find('#sickcommon-line-total')

    this.$form.on('change', this.handleChangeForm.bind(this))
    this.$form.on('input', this.handleSubmitForm.bind(this))
    this.$inputs.on('keyup', this.handleChangeForm.bind(this))
    if (this.$eligibility && this.$eligibility.length) {
      this.$eligibility.on('change', this.handleChangeForm.bind(this))
      this.$eligibility.on('click', this.handleChangeForm.bind(this))
    }

    // run calculation on load with default values
    this.handleChangeForm()
  }

  handleSubmitForm(e) {
    e.preventDefault()
    this.handleChangeForm()
  }

  handleChangeForm() {
    this.$containerWithResult.show()
    this.$containerWithoutResult.hide()

    let monthlyFee = this.toFloat(this.$feeInput.val())
    let monthlyBase = this.toFloat(this.$baseInput.val())
    let leaveDays = this.toInt(this.$daysInput.val())

    const minAllowed = this.baseLimits.min
    const maxAllowed = this.baseLimits.max
    if (monthlyBase > maxAllowed || monthlyBase < minAllowed) {
      this.$error.show()
      this.$details.hide()

      this.applyValue(this.$benefitMonths, '—')
      this.applyValue(this.$monthlyAmount, '—')
      this.applyValue(this.$netAmount, '—')

      return
    }

    this.$error.hide()
    this.$details.show()

    if (leaveDays === 0) {
      this.$containerWithResult.hide()
      this.$containerWithoutResult.show()
      return
    }

    let drb = monthlyBase / 30

    let eligible = true
    if (this.$eligibility && this.$eligibility.length) {
      eligible = !!this.$eligibility.prop('checked')
    }

    let grossSubsidy = 0
    let feeCosts = 0
    let net = 0

    const t1End = this.tiers.tier1End
    const t2End = this.tiers.tier2End
    let days_end_1 = Math.min(leaveDays, t1End)
    let days_4_20 = 0
    let days_21_plus = 0
    let daily_amount_2 = 0
    let daily_amount_3 = 0
    let result_1 = 0
    let result_2 = 0
    let result_3 = 0

    if (eligible) {
      days_4_20 = Math.max(0, Math.min(leaveDays, t2End) - t1End)
      days_21_plus = Math.max(0, leaveDays - t2End)

      daily_amount_2 = this.round2(drb * this.rates.tier2)
      daily_amount_3 = this.round2(drb * this.rates.tier3)

      result_1 = 0
      result_2 = this.round2(daily_amount_2 * days_4_20)
      result_3 = this.round2(daily_amount_3 * days_21_plus)

      grossSubsidy = result_2 + result_3

      const maxDaysFee = this.maxMonthsFee * 30
      const daysCharged = Math.min(leaveDays, maxDaysFee)
      feeCosts = (monthlyFee / 30) * daysCharged

      net = Math.max(0, grossSubsidy - feeCosts)
    }

    let grossRounded = this.round2(grossSubsidy)
    let feeRounded = this.round2(feeCosts)
    let netRounded = this.round2(net)

    this.applyValue(this.$monthlyAmount, grossRounded)
    this.applyValue(this.$benefitMonths, feeRounded)
    this.applyValue(this.$netAmount, netRounded)

    // render detail lines
    let drbRounded = this.round2(drb)

    this.renderLine(this.$line1, {
      '%%days_end_1%%': days_end_1,
      '%%result_1%%': result_1
    })
    this.$line1.show()

    if (leaveDays > t1End && eligible) {
      this.renderLine(this.$line2, {
        '%%drb%%': drbRounded,
        '%%rate_2%%': Math.round(this.rates.tier2 * 100) + '%',
        '%%daily_amount_2%%': daily_amount_2,
        '%%days_count_2%%': days_4_20,
        '%%days_end_2%%': Math.min(leaveDays, t2End),
        '%%result_2%%': result_2
      })
      this.$line2.show()
    } else {
      this.$line2.hide()
    }

    if (leaveDays > t2End && eligible) {
      this.renderLine(this.$line3, {
        '%%drb%%': drbRounded,
        '%%rate_3%%': Math.round(this.rates.tier3 * 100) + '%',
        '%%daily_amount_3%%': daily_amount_3,
        '%%days_count_3%%': days_21_plus,
        '%%days_end_3%%': leaveDays,
        '%%result_3%%': result_3
      })
      this.$line3.show()
    } else {
      this.$line3.hide()
    }

    this.renderLine(this.$lineTotal, {
      '%%total_days%%': leaveDays,
      '%%total%%': grossRounded
    })
    this.$lineTotal.show()
  }

  toInt(v) {
    let n = parseInt(String(v), 10)
    return Number.isFinite(n) ? n : 0
  }

  toFloat(v) {
    let n = parseFloat(String(v))
    return Number.isFinite(n) ? n : 0
  }

  round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100
  }

  applyValue($el, value) {
    if (!$el || !$el.length) return
    let template = $el.data('value') || '%%value%%'
    $el.text(String(template).replace('%%value%%', value))
  }

  renderLine($el, vars) {
    if (!$el || !$el.length) return
    let template = $el.data('template') || ''
    let text = String(template)
    for (const [key, val] of Object.entries(vars)) {
      text = text.replace(key, val)
    }
    $el.text(text)
  }
}
